import moment from 'moment';
import {
  fetchEftHistory,
  fetchEftExtensions,
  downloadEftInvoice,
  fetchRetailerEFTDetailDate,
} from 'dashboard/actions/eft-history/eft-history.actions';
import { initGrid } from 'utils/grid/grid';
import template from './eft-history.html';

const mapStateToThis = ({ eftHistory, session, config, dictionary }) => {
  const { serverTime, retailer, locale } = session;
  const { defaultPageNo, pageSizeKey, defaultPageSizes, sortColumnKey, directionKey, usesMultipleSweepDates } = config;
  const terms = dictionary.terms[locale];
  const { items, isLoading, extensions, date } = eftHistory;

  return {
    serverTime,
    retailer,
    defaultPageNo,
    pageSizeKey,
    defaultPageSizes,
    sortColumnKey,
    directionKey,
    items,
    isLoading,
    extensions,
    usesMultipleSweepDates,
    terms,
    date,
  };
};

const mapDispatchToThis = {
  fetchEftHistory,
  fetchEftExtensions,
  downloadEftInvoice,
  fetchRetailerEFTDetailDate,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'gettextCatalog', '$state')
class EftHistoryController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    await Promise.all([this.fetchEftExtensions(), this.fetchRetailerEFTDetailDate(this.retailerId)]);
    this.headers = this.getHeaders();
    this.minDate = moment(this.date).subtract(24, 'months').toDate().toDateString();
    this.defaultParams = {
      [this.sortColumnKey]: 'date',
      [this.directionKey]: false,
      [this.pageSizeKey]: this.defaultPageSizes[2],
    };
    this.gridModel = await initGrid(this.fetchEftHistory, this.defaultParams);
    this.initializeFilters();
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  preserveFilters() {
    this.preservedFilters = { ...this.gridModel.pagingModel.filters };
  }

  initializeFilters() {
    this.gridModel.pagingModel.filters = {
      startDate: moment(this.date).subtract(12, 'weeks').toDate(),
      endDate: moment(this.date).toDate(),
      retailerId: this.retailerId,
    };
  }

  search() {
    this.maintenance = false;
    this.gridModel
      .applyFilters()
      .then(() => {
        this.preserveFilters();
      })
      .catch((err) => {
        console.error('EFT_HISTORY', err);
        this.maintenance = true;
      });
  }

  clearFilter() {
    this.initializeFilters();
    return this.search();
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Date'),
        field: 'date',
        sortable: true,
      },
      this.usesMultipleSweepDates
        ? {
            text: this.gettextCatalog.getString('Total Amount'),
            field: 'eftTotalAmount',
            sortable: true,
            textAlignment: 'text-center',
          }
        : null,
      !this.usesMultipleSweepDates
        ? {
            text: this.gettextCatalog.getString('EFT Amount'),
            field: 'eftAmount',
            sortable: true,
            textAlignment: 'text-center',
          }
        : null,
      !this.usesMultipleSweepDates
        ? {
            text: this.gettextCatalog.getString('EFT Due Date'),
            field: 'eftSweepDate',
            sortable: true,
            textAlignment: 'text-center',
          }
        : null,
      this.usesMultipleSweepDates
        ? {
            /// {{ instant }} is Lottery term using to determine Instant games.
            text: this.gettextCatalog.getString('{{ instant }} EFT Amount', { instant: this.terms.INSTANT.plural }),
            field: 'eftInstantAmount',
            sortable: true,
            textAlignment: 'text-center',
          }
        : null,
      this.usesMultipleSweepDates
        ? {
            /// {{ instant }} is Lottery term using to determine Instant games.
            text: this.gettextCatalog.getString('{{ instant }} EFT Due Date', { instant: this.terms.INSTANT.plural }),
            field: 'eftInstantSweepDate',
            sortable: true,
            textAlignment: 'text-center',
          }
        : null,
      this.usesMultipleSweepDates
        ? {
            /// {{ draw }} is Lottery term using to determine Draw games.
            text: this.gettextCatalog.getString('{{ draw }} EFT Amount', { draw: this.terms.DRAW.plural }),
            field: 'eftDrawAmount',
            sortable: true,
            textAlignment: 'text-center',
          }
        : null,
      this.usesMultipleSweepDates
        ? {
            /// {{ draw }} is Lottery term using to determine Draw games.
            text: this.gettextCatalog.getString('{{ draw }} EFT Due Date', { draw: this.terms.DRAW.plural }),
            field: 'eftDrawSweepDate',
            sortable: true,
            textAlignment: 'text-center',
          }
        : null,
      {
        text: this.gettextCatalog.getString('Download'),
        textAlignment: 'text-right',
      },
    ];
  }

  onDownloadReport(invoice, extension) {
    const { invoiceWeekEndDate } = invoice;
    return this.downloadEftInvoice(this.retailerId, invoiceWeekEndDate, extension);
  }
}

export default class EftHistoryComponent {
  constructor() {
    this.template = template;
    this.controller = EftHistoryController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/eft-amount/components/eft-history-component.js